import { observer } from 'mobx-react-lite';
import { usePluginStore } from '../../../store/RootStoreContext';
import AgentChatComponent from './AgentChatComponent';

interface Props {
    isChildrenVisible: boolean;
}

// const styles = {
//     chatAppLoading: { display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '35%' }
// };

// This component is responsible to control chat app status and render AgentChatComponent only if chatAppStatus is ready
const AgentChatContainer = ({ isChildrenVisible }: Props) => {
    const {
        chatPlugin
        // pluginsErrors: { CHAT: chatPluginErrors },
        // pluginIsInitializing: { CHAT: chatPluginIsInitializing }
    } = usePluginStore();

    const pluginId = chatPlugin?.manifest?.pluginId;
    // const isInitializing = chatPluginIsInitializing?.[pluginId] ?? true;

    // return !pluginId || isInitializing ? (
    //     <Spin style={styles.chatAppLoading} />
    // ) : (
    return <AgentChatComponent isVisible={isChildrenVisible} pluginId={pluginId} />;
    // );
};

export default observer(AgentChatContainer);
